import Axios from "axios";

const INITIAL_STATE = {
  regional: {
    total: 0,
    perPage: 0,
    page: 0,
    lastPage: 0,
    data: [
      {
        city: null,
        business_hours: null,
        address: null,
        phones: null,
        emails: null,
        image_path: null,
        delegate: null,
        latitude: null,
        longitude: null,
      },
    ],
  },
};

export const updateRegional = param => ({
  type: "SET_REGIONAL",
  payload: param,
});

export const getRegional = (url, config) => (dispatch, getState) => {
  return Axios.get(url, config)
    .then(resp => {
      dispatch(updateRegional(resp.data));
    })
    .catch(function (error) {});
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "SET_REGIONAL":
      return { ...state, regional: action.payload };
    default:
      return state;
  }
};
